require('./bootstrap');
require('./nav');

window.Vue = require('vue');

import domtoimage from 'dom-to-image';

// events buffer
window.eventsBuffer = new Vue();
window.domtoimage = domtoimage;

// App views
import proLitViews from './ViewsBootstraping'

// global componets
Vue.component('prolit-app', require('./components/ProLitApp'));
Vue.component('csl-select', require('./components/form-componets/CslSelect'));
Vue.component('contact-map', require('./components/ContactMap'));
Vue.component('prolit-button', require('./components/form-componets/ProlitButton'));

// 3er party elements
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import enLocale from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import swal from 'sweetalert';


Vue.use(ElementUI);
locale.use(enLocale);


const app = new Vue({
    el: '#app',
    methods:{
        getGlobalVars(dataKey){

			if(this.$refs.prolit){
        		return dataKey && this.$refs.prolit.appData && this.$refs.prolit.appData.app && this.$refs.prolit.appData.app.hasOwnProperty(dataKey)
					? this.$refs.prolit.appData.app[dataKey]
					: this.$refs.prolit.appData;
			}
			
			return {};
        },
        
        getScopeApp(){
			return this.$refs.prolit
				? this.$refs.prolit
				: {};
        
        },
        
        getScopePage(){
			return this.$refs.prolit && this.$refs.prolit.$refs.page
				? this.$refs.prolit.$refs.page
				: {};
        },
    },
	mounted(){
		document.addEventListener('DOMContentLoaded', () => {
			eventsBuffer.$emit('contentLoaded', {status:true});
			prolitEvents.$emit('contentLoaded', {status:true});
            if(window.App.flash && window.App.flash !== null){
                //this.appVars.flash = JSON.parse(this.appVars.flash);

                swal({
                    title: window.App.flash.title,
                    text: window.App.flash.message,
                    icon: window.App.flash.type,
                    button: "OK",
                })
            }
		})
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js